var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        id: "deleteModal",
        footer: null,
        closable: false,
        header: null,
        visible: true,
      },
    },
    [
      _c(
        "div",
        { staticClass: "delete-modal-cancel", on: { click: _vm.handleCancel } },
        [
          _c(
            "span",
            {
              staticClass: "md-icon",
              staticStyle: { color: "#ec4b1d", cursor: "pointer" },
            },
            [_vm._v("cancel")]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "delete-modal-image" },
        [
          _c("DeleteModalIcon", {
            staticStyle: { width: "400px", "max-height": "200px" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("p", { staticClass: "delete-modal-text" }, [
        _vm._v(_vm._s(_vm.description)),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "delete-modal-slot" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _vm.modalBtnVisible
        ? _c("div", { staticClass: "delete-modal-btn" }, [
            _c(
              "button",
              {
                staticClass: "push-btn-give-up",
                on: { click: _vm.handleCancel },
              },
              [
                _vm._v(
                  "\n            " + _vm._s(_vm.btnCancelText) + "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "push-btn", on: { click: _vm.handleConfirm } },
              [_vm._v("\n            " + _vm._s(_vm.btnoktext) + "\n        ")]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }